(function() {
  'use strict';
  if (!document.querySelector('.km-poster-item')) return;
  document.body.classList.add('km-product-page');

  var T = (window.KM_LANG === 'en') ? {
    showMore: 'View 12 more designs', showLess: 'Show fewer designs',
    step1: 'Choose a card', step2: 'Your name', step3: 'Event type',
    stickyHelp: 'Choose a card and enter your name',
    stickyCta: 'Add to cart - 49.99 EUR'
  } : {
    showMore: 'Voir les 12 autres designs', showLess: 'Afficher moins de designs',
    step1: 'Choisir une carte', step2: 'Votre prénom', step3: 'Type d\'événement',
    stickyHelp: 'Choisissez une carte et indiquez votre prénom',
    stickyCta: 'Ajouter au panier - 49,99 EUR'
  };
  // === B : Trust badges above-the-fold ===
  function kmInjectTrustBadges() {
    if (document.querySelector('.km-trust-strip')) return;

    var SVG = {
      lock: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect width="18" height="11" x="3" y="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
      shield: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>',
      bolt: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M13 2 3 14h9l-1 8 10-12h-9l1-8z"/></svg>',
      phoneOff: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07"/><path d="M22 2 2 22"/><path d="M4 4h.01M3.42 8a16 16 0 0 0-.86 5.74A19.5 19.5 0 0 0 6.07 19"/></svg>',
      userX: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="17" x2="22" y1="8" y2="13"/><line x1="22" x2="17" y1="8" y2="13"/></svg>'
    };

    var TRUST = (window.KM_LANG === 'en') ? [
      {svg: SVG.lock, text: 'Secure payment'},
      {svg: SVG.shield, text: '30-day money-back'},
      {svg: SVG.bolt, text: 'Instant delivery'},
      {svg: SVG.phoneOff, text: 'No app required'},
      {svg: SVG.userX, text: 'No signup required'}
    ] : [
      {svg: SVG.lock, text: 'Paiement sécurisé'},
      {svg: SVG.shield, text: 'Remboursé sous 30 jours'},
      {svg: SVG.bolt, text: 'Livraison instantanée'},
      {svg: SVG.phoneOff, text: 'Sans application'},
      {svg: SVG.userX, text: 'Sans inscription'}
    ];

    var strip = document.createElement('div');
    strip.className = 'km-trust-strip';
    TRUST.forEach(function(item) {
      var pill = document.createElement('span');
      pill.className = 'km-trust-pill';
      pill.innerHTML = '<span class="km-trust-icon">' + item.svg + '</span><span class="km-trust-text">' + item.text + '</span>';
      strip.appendChild(pill);
    });

    var insertionAnchor = document.querySelector('h1.product__title, .product__title, h1');
    if (!insertionAnchor) {
      insertionAnchor = document.getElementById('km-posters-grid');
      if (insertionAnchor && insertionAnchor.parentElement) {
        insertionAnchor.parentElement.insertBefore(strip, insertionAnchor);
      }
      return;
    }
    if (insertionAnchor.parentElement) {
      insertionAnchor.parentElement.insertBefore(strip, insertionAnchor.nextSibling);
    }
  }
  kmInjectTrustBadges();

  // === Sprint 4.2 - 3 témoignages above-the-fold ===
  function kmInjectTestimonials() {
    var trustStrip = document.querySelector('.km-trust-strip');
    if (!trustStrip || document.querySelector('.km-testimonials-strip')) return;

    var TESTIMONIALS_FR = [
      {
        initials: 'EG', name: 'Emeline G.', color: '#C9A96E',
        quote: 'Top, rien à dire. On a récupéré environ 650 photos et vidéos de nos invités sans courir après. Simple, rapide, prix correct.'
      },
      {
        initials: 'CH', name: 'Céline H.', color: '#8C7B6E',
        quote: "Hyper simple d'utilisation pour partager le QR code et créer une galerie commune. Service réactif. Je recommande sans souci."
      },
      {
        initials: 'LC', name: 'Léa C.', color: '#3D3530',
        quote: "Super service, même après l'achat. Facile à utiliser et a fait forte sensation auprès des invités qui ont partagé plein de photos."
      }
    ];

    var TESTIMONIALS_EN = [
      {
        initials: 'EG', name: 'Emeline G.', color: '#C9A96E',
        quote: "Couldn't ask for more. We got about 650 photos and videos from our guests without chasing anyone. Simple, fast, fair price."
      },
      {
        initials: 'CH', name: 'Céline H.', color: '#8C7B6E',
        quote: "Super easy to share the QR code and create a shared gallery. Responsive support. I recommend without hesitation."
      },
      {
        initials: 'LC', name: 'Léa C.', color: '#3D3530',
        quote: "Great service, even after the purchase. Easy to use and made a real impression on our guests who shared tons of photos."
      }
    ];

    var data = (window.KM_LANG === 'en') ? TESTIMONIALS_EN : TESTIMONIALS_FR;

    var strip = document.createElement('div');
    strip.className = 'km-testimonials-strip';

    data.forEach(function(t) {
      var card = document.createElement('div');
      card.className = 'km-testimonial-card';
      card.innerHTML =
        '<div class="km-testimonial-header">' +
          '<div class="km-testimonial-avatar" style="background-color:' + t.color + '">' + t.initials + '</div>' +
          '<div class="km-testimonial-meta">' +
            '<div class="km-testimonial-name">' + t.name + '</div>' +
            '<div class="km-testimonial-stars">\u2605\u2605\u2605\u2605\u2605</div>' +
          '</div>' +
        '</div>' +
        '<p class="km-testimonial-quote">' + t.quote + '</p>';
      strip.appendChild(card);
    });

    trustStrip.parentElement.insertBefore(strip, trustStrip.nextSibling);
  }
  kmInjectTestimonials();

  var firstPoster = document.querySelector('.km-poster-item');
  var posterContainer = firstPoster ? firstPoster.parentElement : null;
  var nameInput = document.getElementById('km-customer-name');
  var eventInput = document.getElementById('km-event-type');

  // Card collapse toggle
  if (posterContainer) {
    posterContainer.classList.add('km-step23-collapsed');
    var moreBtn = document.createElement('button');
    moreBtn.type = 'button';
    moreBtn.className = 'km-show-more-cards';
    moreBtn.textContent = T.showMore;
    moreBtn.addEventListener('click', function() {
      var expanded = posterContainer.classList.toggle('km-step23-expanded');
      posterContainer.classList.toggle('km-step23-collapsed', !expanded);
      moreBtn.textContent = expanded ? T.showLess : T.showMore;
    });
    if (posterContainer.parentElement) {
      posterContainer.parentElement.insertBefore(moreBtn, posterContainer.nextSibling);
    }
  }

  // Progress tracker
  var tracker = document.createElement('div');
  tracker.className = 'km-progress-tracker';
  tracker.innerHTML =
    '<div class="km-progress-step" data-step="card">' + T.step1 + '</div>' +
    '<div class="km-progress-step" data-step="name">' + T.step2 + '</div>' +
    '<div class="km-progress-step" data-step="event">' + T.step3 + '</div>';
  if (posterContainer && posterContainer.parentElement) {
    posterContainer.parentElement.insertBefore(tracker, posterContainer);
  }
  // === A : Pré-sélection automatique carte par défaut ===
  function kmPreSelectDefault() {
    if (typeof window.kmOpenModal !== 'function' || typeof window.kmSelectFromModal !== 'function') return;
    var modal = document.getElementById('km-modal');
    if (!modal) return;

    var origVisibility = modal.style.visibility;
    var origDisplay = modal.style.display;
    modal.style.visibility = 'hidden';

    try {
      window.kmOpenModal(2);
      window.kmSelectFromModal();
      var closeBtn = document.getElementById('km-modal-close');
      if (closeBtn) closeBtn.click();
    } catch (e) {
      console.log('[KM] Pre-select skipped:', e.message);
    } finally {
      setTimeout(function() {
        modal.style.visibility = origVisibility || '';
        modal.style.display = origDisplay || '';
      }, 100);
    }

    var preSelectHint = document.createElement('div');
    preSelectHint.className = 'km-preselect-hint';
    preSelectHint.textContent = (window.KM_LANG === 'en')
      ? 'A default card is pre-selected. Click any other to change.'
      : 'Une carte est pr\u00e9-s\u00e9lectionn\u00e9e par d\u00e9faut. Cliquez sur une autre pour changer.';
    var posterContainerEl = document.getElementById('km-posters-grid');
    if (posterContainerEl && posterContainerEl.parentElement) {
      posterContainerEl.parentElement.insertBefore(preSelectHint, posterContainerEl);
    }
  }

  if (document.readyState === 'complete') {
    setTimeout(kmPreSelectDefault, 800);
  } else {
    window.addEventListener('load', function() { setTimeout(kmPreSelectDefault, 800); });
  }

  function isCardChosen() {
    // Real selection mechanism: class 'selected' added by selectPoster()
    if (document.querySelector('.km-poster-item.selected')) return true;
    // Fallback checks
    if (window.kmPosters && Array.isArray(window.kmPosters)) {
      var anySelected = window.kmPosters.some(function(p) { return p.selected === true; });
      if (anySelected) return true;
    }
    if (document.querySelector('.km-poster-item[aria-selected="true"]')) return true;
    var sel = document.getElementById('km-selected-name');
    if (sel && sel.textContent && sel.textContent.indexOf('Aucun') === -1 && sel.textContent.indexOf('No design') === -1 && sel.textContent.trim().length > 2) return true;
    return false;
  }

  function updateTracker() {
    var card = isCardChosen();
    var n = nameInput && nameInput.value.trim().length > 0;
    var e = eventInput && eventInput.value.trim().length > 0;
    var cs = tracker.querySelector('[data-step="card"]');
    var ns = tracker.querySelector('[data-step="name"]');
    var es = tracker.querySelector('[data-step="event"]');
    if (cs) cs.classList.toggle('km-done', card);
    if (ns) ns.classList.toggle('km-done', n);
    if (es) es.classList.toggle('km-done', e);
    return card && n;
  }

  // Sticky CTA mobile
  var sticky = document.createElement('div');
  sticky.className = 'km-sticky-cta';
  sticky.innerHTML =
    '<button type="button" id="km-sticky-cta-btn" disabled>' + T.stickyCta + '</button>' +
    '<span class="km-sticky-help">' + T.stickyHelp + '</span>';
  document.body.appendChild(sticky);

  function updateSticky() {
    var ready = updateTracker();
    var btn = document.getElementById('km-sticky-cta-btn');
    var help = sticky.querySelector('.km-sticky-help');
    if (btn) btn.disabled = !ready;
    if (help) help.style.display = ready ? 'none' : 'block';
  }

  // ADAPTE: #km-atc-btn est le vrai CTA (fetch /cart/add.js)
  var REAL_CTA_SELECTOR = '#km-atc-btn';

  document.getElementById('km-sticky-cta-btn').addEventListener('click', function() {
    var realCta = document.querySelector(REAL_CTA_SELECTOR);
    if (realCta) {
      realCta.scrollIntoView({behavior: 'smooth', block: 'center'});
      setTimeout(function() { realCta.click(); }, 300);
    }
  });

  if (nameInput) {
    nameInput.addEventListener('input', function() { updateTracker(); updateSticky(); });
  }
  if (eventInput) {
    eventInput.addEventListener('input', function() { updateTracker(); updateSticky(); });
  }

  // Polling fallback — covers modal selection via selectPoster()
  setInterval(updateSticky, 1500);

  updateSticky();
})();